import Button from '@doordash/component-button'
import { Text, StackChildren, Colors, Inline } from '@doordash/design-language'
import { Steps } from '../../../utilities/steps'
import * as React from 'react'
import scheduleOrientationStrings from './strings'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { connect } from 'react-redux'
import { redirectToProgressionPage } from '../../../actions/redirectToProgressionPage'
import routes from '../../../routes'

type ScheduleOrientationStepProps = DispatchProps & RouterProps & OwnProps

interface RouterProps {
  history?: History
}

interface DispatchProps {
  redirectToProgressionPage?: (value?: boolean) => void
}

export interface OwnProps {
  uniqueLink?: string
  isStepCompleted?: boolean
}

const ScheduleOrientationStep: React.FC<ScheduleOrientationStepProps> = props => {
  const { uniqueLink, isStepCompleted, redirectToProgressionPage } = props

  const handleClick = () => {
    const step = isStepCompleted ? Steps.Reschedule : Steps.Orientation

    redirectToProgressionPage(false)

    const pathname = routes.dasherflow.buildPath({
      uniqueLink,
      step,
    })

    props.history.push(pathname)
  }

  return (
    <StackChildren>
      <Text color={Colors.SystemGrey80}>
        {scheduleOrientationStrings.progressionCheckScheduleOrientationDescription()}
      </Text>
      <div>
        <Inline tag={'span'} size={Inline.Sizes.XxSmall}>
          <Button
            type={Button.Types.PrimaryPill}
            size={Button.Sizes.Small}
            tag="a"
            onClick={handleClick}
            isInline
          >
            {isStepCompleted
              ? scheduleOrientationStrings.scheduleOrientationDetails__reschedule()
              : scheduleOrientationStrings.progressionCheckScheduleOrientationButtonText()}
          </Button>
        </Inline>
      </div>
    </StackChildren>
  )
}
const mapDispatchToProps = {
  redirectToProgressionPage,
}

export default withRouter(
  connect(null, mapDispatchToProps)(ScheduleOrientationStep)
)
